<template>
	<div class="container-md mh-100">
		<LayoutHeaderSection>
			<template #title>
				<LayoutTextSection text="Perfil de la empresa" :breadcrumb="true" />
			</template>
			<template #actions>
				<div class="hstack gap-2 justify-content-md-end">
					<CommonButtonCompanyAdminSettingOption />
				</div>
			</template>
		</LayoutHeaderSection>
		<main class="pt-8 vstack gap-10">
			<CommonFormWrapper submitText="Guardar" :cancelUrl="{ name: 'company.admin.home' }" :submitting="submitting" :errors="validationExternal" @submit="submit">
				<template #body>
					<CommonFormInputText v-model="form.name" title="Nombre" subtitle="Obligatorio" placeholder="Ingresa tu nombre" :focus="true" :validation="validation.name" />
					<CommonFormInputSelect v-model="form.country_code" title="País" subtitle="Obligatorio" placeholder="Seleccionar el país" :options="$env.GENERAL.countries" :validation="validation.country_code" />
					<CommonFormInputImage v-model="form.avatar" :imageUrl="form?.avatar_url" title="Avatar" titleModal="Cambiar avatar" :rounded="true" @remove="removeImage" />
				</template>
			</CommonFormWrapper>
		</main>
	</div>
</template>

<script>
	import { reactive, computed } from 'vue';
	import router from '@/router';
	import store from '@/store';
	import _ from 'lodash';
	import useVuelidate from '@vuelidate/core';
	import { helpers } from '@vuelidate/validators';
	import { required, minLength, maxLength } from '@/helpers/i18n/validators';
	import composableForm from '@/composables/form';
	import CompanyAdminCompanyRepository from '@/repositories/modules/Company/Admin/Company';

	export default {
		setup() {
			const { submitting, validationExternal, catchError } = composableForm();
			const company = computed(() => store.getters['company/info']);

			const form = reactive({
				name: company.value?.name,
				country_code: company.value?.country_code,
				avatar: null,
				avatar_url: company.value?.avatar_url
			});

			const validation = useVuelidate({
				name: {
					required,
					minLength: minLength(3),
					maxLength: maxLength(150)
				},
				country_code: {
					required
				}
			}, form);

			const submit = async () => {
				if(submitting.value) return;
				validationExternal.value = [];
				if(!await validation.value.$validate()) return;

				submitting.value = true;
				await CompanyAdminCompanyRepository.update(form).then((response) => {
					store.dispatch('company/setInfo', response.data);
					router.push({ name: 'company.admin.home' });
				}).catch(catchError);
				submitting.value = false;
			}

			const removeImage = () => {
				form.avatar_url = null;
			}

			return { form, submit, removeImage, submitting, validation, validationExternal };
		}
	}
</script>